<template>
	<div class="user-center-container">
		<div class="user-center-header filter-container">
			<!-- 搜索条件区域 -->
			<div class="search-container">
				<div class="search-form">
					<div class="form-item">
						<span class="label">名称</span>
						<el-input v-model="queryParams.policyTitle" placeholder="请输入名称" clearable></el-input>
					</div>
					<div class="form-buttons">
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleResetSearch">重置</el-button>
						<el-button :disabled="multiple" type="primary" plain @click="handleRmoveAllSubscribe">
							批量取消订阅
						</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="user-center-content">
			<!-- 列表区域 -->
			<data-table
				:table-data="useSubscribePolicyList"
				:column="columns"
				:page-options="pageOptions"
				:border="true"
				:loading="loading"
				:selection="true"
				:reserve-selection="true"
				:row-keys="handleRowKeys"
				@selectionChange="handleSelectDataChange"
				@page-change="handlePaginationChange"
			>
				<template slot="tools" slot-scope="data">
					<el-button @click="handleRmoveSubscribe(data.scope.row)">取消订阅</el-button>
				</template>
			</data-table>
		</div>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { pageUserSubscribePolicy, unSubscribePolicy } from '@/api/userCenter/index'

	// 我的政策快讯订阅
	export default {
		name: 'UserSubscription',
		components: {
			DataTable
		},
		props: {},
		data() {
			return {
				queryParams: {
					policyTitle: ''
				},
				columns: [
					{ label: '名称', prop: 'policyTitle', align: 'center' },
					{ label: '订阅日期', prop: 'subscribeTime', width: '180', align: 'center' },
					{ label: '操作', prop: '', align: 'center', width: '150', slot: 'tools' }
				],
				// 用户订阅的政策资讯信息
				useSubscribePolicyList: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 非多个禁用
				multiple: true,
				// 选中的id集合
				selectIds: []
			}
		},
		computed: {},
		watch: {},
		created() {
			this.getUserSubcribePolicyList()
		},
		mounted() {},
		methods: {
			// 查询用户收藏的政策资讯信息
			getUserSubcribePolicyList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				pageUserSubscribePolicy(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							this.useSubscribePolicyList = data.records
							this.pageOptions.total = data.total || 0
						} else {
							this.useSubscribePolicyList = []
							this.pageOptions.total = 0
						}
						this.loading = false
					})
					.catch(() => {
						this.loading = false
						this.useSubscribePolicyList = []
						this.pageOptions.total = 0
					})
			},

			handleRowKeys(row) {
				return row.id
			},

			// 选中回调
			handleSelectDataChange(selection) {
				this.selectIds = selection.map(item => item.id)
				this.multiple = !selection.length
			},

			// 分页变化
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.getUserSubcribePolicyList()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.getUserSubcribePolicyList()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					policyTitle: ''
				}
				this.getUserSubcribePolicyList()
			},

			// 用户取消订阅
			handleRmoveSubscribe(item) {
				const data = {
					policyFlashIds: [item.id]
				}

				unSubscribePolicy(data).then(response => {
					this.getUserSubcribePolicyList()
					this.$message.success('取消订阅成功')
				})
			},

			// 批量取消订阅
			handleRmoveAllSubscribe() {
				const selectedIds = this.selectIds

				const data = {
					policyFlashIds: selectedIds
				}

				unSubscribePolicy(data).then(response => {
					this.getUserSubcribePolicyList()
					this.$message.success('取消订阅成功')
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
</style>
